import { useCallback } from 'react';
import { useLocation } from '@remix-run/react';
import { useAuth } from '@modules/root/context';
import type { PinItemType } from '~/modules/moodboards/type';

interface GuestPinContext {
    pinId: number;
    pinType: PinItemType;
    libraryItemId?: number;
    items?: { id: number; libraryItemId?: number }[];
}

/**
 * Hook that manages the guest save flow for the FollowSelector.
 *
 * When a logged-out user clicks save we only open the auth modal.
 * Users choose a board explicitly after login by clicking save again.
 */
export const useGuestSave = () => {
    const { showAuthModal } = useAuth();
    const { pathname, search } = useLocation();

    /**
     * Open the auth modal for logged-out save attempts.
     * Called when a logged-out user clicks a heart/save icon.
     */
    const guestSave = useCallback(
        (_pin: GuestPinContext) => {
            const currentUrl = `${pathname}${search}`;
            showAuthModal({
                authSource: 'designBoard',
                redirect: currentUrl,
                skipPostSignUp: true,
            });
        },
        [pathname, search, showAuthModal],
    );

    return { guestSave };
};
